import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'

interface ScrollTopButtonProps {
  /** С какой прокрутки показывать кнопку. */
  threshold?: number
}

/**
 * Кнопка «Наверх». Нужна там, где список длинный: в результатах поиска
 * возвращаться к строке поиска пальцем долго.
 */
const ScrollTopButton = ({ threshold = 600 }: ScrollTopButtonProps) => {
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])

  if (!isVisible) return null

  return (
    <button
      type="button"
      className="home-scroll-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Наверх"
    >
      <ArrowUp size={20} aria-hidden />
    </button>
  )
}

export default ScrollTopButton
